module.exports = __webpack_public_path__ + "media/agent_3_buruburu.a633468a.mp3";